// The answers the preference questions offer, with the words each one is shown
// with. The preferences screen and the inline cards in the Improve queue both
// read these, so the two never describe the same answer differently.

import type { AlignmentIntent, GoalPriority } from './types.ts';

export const GOAL_OPTIONS: { value: GoalPriority; label: string; sub: string }[] = [
  { value: 'max_music', label: 'Pack in more sets', sub: 'See more music, even if it means more walking' },
  { value: 'stay_together', label: 'Stay close to my crew', sub: 'Give shared sets and meetup plans more weight' },
  { value: 'headliners_and_rest', label: 'Protect the sets that matter most', sub: 'Leave more room around high-priority artists' },
  { value: 'discover', label: 'Make room for discovery', sub: 'Give unfamiliar artists a little more weight' },
];

export const COMPANY_OPTIONS: { value: AlignmentIntent; label: string; sub: string }[] = [
  { value: 'solo', label: 'Just me', sub: 'Optimize around my picks' },
  { value: 'subset', label: 'A few people', sub: 'Use selected friends when their plans matter' },
  { value: 'everyone', label: 'My whole group', sub: 'Prefer choices that work for the group' },
];
